'use strict';

wbApp.directive('wbCourseTypeImageCombo', ['$timeout', '$translate', 'courseTypeImageSvc',
    function ($timeout, $translate, courseTypeImageSvc) {
        function formatResult(model) {
            if (!model) { return; }

            return "<img style='width: 45px; height: 45px; margin-right: 20px;' src='" + model.imageUrl + "'/> ";
        }

        function formatSelection(model) {
            return "<img style='width: 20px; height: 20px; margin-right: 10px;' src='" + model.imageUrl + "'/> ";
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {

                var models = courseTypeImageSvc.getAllAsync();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_COURSE_TYPE_IMAGE'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        id: function (courseTypeImage) { return courseTypeImage.imageUri; },
                        data: models
                    });

                    ctrl.$render = function () {
                        models.$promise.then(function () {
                            $(elm).select2('val', ctrl.$viewValue);
                        });
                    }

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    ctrl.$render();

                }, 1);
            }
        }
    }]);    